var map = {
	"./bhimkanta.jpg": "b1f2",
	"./bishnu.jpg": "2c0a",
	"./bishnu.png": "52b6",
	"./damodar_baniya.jpg": "10b9",
	"./ghanshyam.jpg": "2d0b",
	"./jagdish.jpg": "3ac9",
	"./janaki.jpg": "1a4a",
	"./jhuplal_khadka.jpg": "42ea",
	"./motiraj.jpg": "79d8",
	"./placeholder.jpg": "fcb4",
	"./ram.jpg": "ea97",
	"./shankar.jpg": "5c2d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a0ae";